<template>
  <q-dialog v-model="shown">
    <q-card :style="{ 'width': '450px', 'max-width': '95%' }">
      <q-form
        ref="formRef"
      >
        <q-card-section
          v-if="refundType"
          class="text-h5"
        >
          Amount to Refund to {{ refundType.label || $_.startCase(refundType.type) }}
        </q-card-section>

        <q-card-section class="row justify-evenly items-center">
          <q-input
            v-if="refundType"
            ref="refundAmount"
            v-model.number="amount"
            label="Amount"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.01"
            :rules="[
              val => val > 0 || 'Must be positive value',
              val => val !== null && val !== '' || 'Cannot be blank',
              val => amountRemaining >= 0 || 'Cannot exceed amount owed',
              val => !refundType.maxAmount || val <= refundType.maxAmount || 'Cannot exceed payment'
            ]"
            autofocus
            @keyup.enter="save"
          />
        </q-card-section>

        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            label="Done"
            color="primary"
            @click="save"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'RefundEditAmountDialog',
  mixins: [FormValidationMixin],
  props: {
    amountRemaining: {
      type: Number,
      required: true
    }
  },
  emits: ['save'],
  data () {
    return {
      shown: false,
      refundType: null,
      amount: 0
    }
  },
  configuration: ['currentCircuit'],
  methods: {
    show (refundType) {
      this.refundType = refundType
      this.shown = true
      this.amount = refundType.amount
    },
    save () {
      this.validateForm(() => {
        this.$emit('save', this.amount, this.refundType)
        this.shown = false
      })
    }
  }
}
</script>
